import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        A new residential community to the North of Norwich City Centre,
        comprising 22 homes, ranging from 5-bedroom townhouses to 1-bed
        apartments, a commercial unit on the prominent corner with Oak Street.
      </p>
      <p>
        The proposals created an enclave for the future residents, incorporating
        a south-facing, shared community terrace with semi-private gardens and
        parking hidden below. Expansive glazing south-facing glazing would
        maximise solar gains, and encourage the integration of the small private
        community.
      </p>
      <p>
        Careful sizing and positioning of windows to the street-facing northern
        facade allows both privacy and minimizing solar losses, adopting the
        ‘fabric first’ approach to sustainability, whereby the layout and
        building envelope are designed to reduce thermal losses to virtually
        zero.
      </p>
      <p>
        Extensive red-brickwork references buildings in Norwich generally, but
        specifically the interesting housing development at The Lathes nearby,
        while a curved red-brick facade to the junction with Oak Street adds a
        new architectural detail to the local vernacular.
      </p>
      <p className="ps">
        This project was completed while Matt was with CSA Design Studio in
        Norfolk. Images courtesy of CSA Design Studio
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/sussex-street-mixed-use.jsx